export enum PostcodeStatus {
  Valid = 1,
  Invalid,
  Loading,
}

export interface Postcode {
  name: string;
  lat: string;
  lng: string;
  status: PostcodeStatus;
}
